/**
 * Shared container-query class presets for technology tab layouts.
 *
 * Main breakpoint:
 * - 50rem (800px): sidebar switches from top (stacked) to left column
 */
export const TECHNOLOGY_TAB_STACK_LAYOUT_CLASS =
  'flex-col items-stretch @min-[50rem]/technology:flex-row @min-[50rem]/technology:items-start';

export const TECHNOLOGY_TAB_SIDEBAR_WIDTH_CLASS = 'w-full @min-[50rem]/technology:w-[280px] 2xl:w-80';

export const TECHNOLOGY_TAB_STACK_LAYOUT_BREAKPOINT_PX = 800;

/**
 * Sticky behavior:
 * - Disabled below 50rem (columns scroll normally, stretch to full width)
 * - Enabled at/above 50rem (sticky positioning, align top)
 *
 * Uses !important to override the inline `align-self: flex-start` set by
 * `useStickyBottom`. Without this, stacked columns resolve width from content
 * instead of the container, causing Recharts charts to overflow.
 */
export const TECHNOLOGY_TAB_STICKY_CLASS =
  '!static !self-stretch @min-[50rem]/technology:!sticky @min-[50rem]/technology:!self-start';

/**
 * History sections:
 * - Below 50rem: horizontal scroll row
 * - At/above 50rem: regular vertical list
 */
export const TECHNOLOGY_TAB_HISTORY_LIST_CLASS =
  'flex gap-2 overflow-x-auto px-1 pb-1 @min-[50rem]/technology:flex-col @min-[50rem]/technology:overflow-visible @min-[50rem]/technology:p-0';

export const TECHNOLOGY_TAB_HISTORY_ITEM_CLASS =
  'min-w-[15rem] shrink-0 w-auto @min-[50rem]/technology:min-w-0 @min-[50rem]/technology:w-full';

/**
 * TRL nav actions:
 * - Keep stacked in narrow panels
 * - Allow 2 columns when enough width is available
 */
export const TECHNOLOGY_TAB_TRL_ACTIONS_GRID_CLASS = 'grid grid-cols-1 gap-2 @min-[38rem]/readiness-nav:grid-cols-2';
